export const LOCALSTORAGE_KEY = 'easydevis'
export const LANGUAGES = [
  'en',
  'fr'
]
